import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { transitionFade } from '../theme/mixins';
import Paper from '../Paper';
import Modal from '../Modal';
export var ModalStyled = styled(Modal).withConfig({
  displayName: "ui-kit-ModalStyled",
  componentId: "ui-kit-1unb8xe"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: none;\n"], ["\n  outline: none;\n"])));
export var ModalContainer = styled.div.withConfig({
  displayName: "ui-kit-ModalContainer",
  componentId: "ui-kit-1asafc7"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ", ".scrollBody & {\n    align-items: flex-start;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 48px;\n    box-sizing: border-box;\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  "
/* sc-sel */
, ".scrollBody & {\n    align-items: flex-start;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 48px;\n    box-sizing: border-box;\n  }\n"])),
/* sc-sel */
ModalStyled);
export var PaperStyled = styled(Paper).withConfig({
  displayName: "ui-kit-PaperStyled",
  componentId: "ui-kit-10frnfb"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin: 48px;\n  position: relative;\n  overflow-y: auto;\n\n  ", "\n\n  &.rounded {\n    border-radius: 12px;\n  }\n\n  ", ".scrollPaper & {\n    flex: 0 1 auto;\n    max-height: calc(100% - 96px);\n  }\n  ", ".scrollBody & {\n    margin: auto;\n  }\n\n  &.fullWidth {\n    width: 100%;\n\n    ", ".scrollBody & {\n      width: initial;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin: 48px;\n  position: relative;\n  overflow-y: auto;\n\n  ", "\n\n  &.rounded {\n    border-radius: 12px;\n  }\n\n  "
/* sc-sel */
, ".scrollPaper & {\n    flex: 0 1 auto;\n    max-height: calc(100% - 96px);\n  }\n  "
/* sc-sel */
, ".scrollBody & {\n    margin: auto;\n  }\n\n  &.fullWidth {\n    width: 100%;\n\n    "
/* sc-sel */
, ".scrollBody & {\n      width: initial;\n    }\n  }\n"])), transitionFade(),
/* sc-sel */
ModalStyled,
/* sc-sel */
ModalStyled,
/* sc-sel */
ModalStyled);
var templateObject_1, templateObject_2, templateObject_3;